import {useCallback, useEffect, useState} from 'react';
import {DealType} from '../models/DealSelection';

const adjustToNearestChunk = (prevValue, newValue, chunk) => {
  if (newValue < chunk) {
    return chunk;
  }
  const chunks = Math.ceil(Math.abs(newValue - prevValue) / chunk);
  if (prevValue < newValue) {
    return prevValue + (chunks * chunk);
  }
  return prevValue - (chunks * chunk);
};

const DEFAULT_QUANTITY = 1;

export const useUserSelection = () => {
  const [quantity, setQuantity] = useState(DEFAULT_QUANTITY);
  const [dealSelection, setDealSelection] = useState(null);

  const setQuantityProxy = value => setQuantity(value || 0);

  const updateQuantity = useCallback(newQuantity => {
    switch (dealSelection?.type) {
      case DealType.BULK_DEAL:
        setQuantityProxy(newQuantity);
        break;
      case DealType.GIFT_DEAL:
        setQuantityProxy(adjustToNearestChunk(quantity, newQuantity, dealSelection?.value?.RLD_Cant__Min__Promocion));
        break;
      case DealType.EXCLUSIVE_DEAL:
        if (newQuantity < dealSelection?.value?.cantidad) {
          setQuantityProxy(dealSelection.value.cantidad);
        } else {
          setQuantityProxy(newQuantity);
        }
        break;
      default:
        setQuantityProxy(newQuantity);
    }
  }, [dealSelection, quantity]);



  useEffect(() => {
    updateQuantity(DEFAULT_QUANTITY);
  }, [dealSelection]);


  return {
    quantity,
    onQuantityChange: updateQuantity,
    dealSelection,
    setDealSelection,
  };
};